import { useStore } from "app/stores";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import ListCheckIn from "./ListCheckIn/ListCheckIn";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import { Grid } from "@material-ui/core";
import ListAdvise from "./ListAdvise/ListAdvise";
import { transformDate } from "app/common/LocalFunction";
import moment from "moment";
import * as Yup from "yup";
const HistoryIndex = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={6}>
        <CheckInDetail patientId={patientId} />
      </Grid>

      <Grid item xs={12} lg={6}>
        <AdviseDetail patientId={patientId} />
      </Grid>
    </Grid>
  );
};

const CheckInDetail = observer(({ patientId }) => {
  const {
    searchCheckIn,
    handleChangeFormSearch,
    openConfirmDelete,
    handleCloseConfirmDialog,
    handleConfirmDeleteCheckIn,
  } = useStore().patientManagementStore.listCheckInStore;
  let [isOpenFillter, setOpenFillter] = useState(true);
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearch({
        ...searchCheckIn,
        fromDate: null,
        toDate: null,
        patientId,
      });
    }
  }, [patientId]);

  // useEffect(() => {
  //   return () => resetStoreDetail();
  // }, []);
  const searchPatientValidationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày bắt đầu không đúng định dạng!")
      .test(
        "from-before-to",
        "Ngày bắt đầu không được lớn hơn ngày kết thúc!",
        function (from) {
          const { toDate } = this.parent;
          if (
            from &&
            toDate &&
            moment(from).isValid() &&
            moment(toDate).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(toDate));
          }
          return true;
        }
      )
      .nullable(),

    toDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày kết thúc không đúng định dạng!")
      .test(
        "to-after-from",
        "Ngày kết thúc không được nhỏ hơn ngày bắt đầu!",
        function (to) {
          const { fromDate } = this.parent;
          if (
            fromDate &&
            to &&
            moment(fromDate).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(fromDate));
          }
          return true;
        }
      )
      .nullable(),
  });
  return (
    <Formik
      initialValues={searchCheckIn}
      validationSchema={searchPatientValidationSchema}
      onSubmit={(values) => {
        handleChangeFormSearch(values);
      }}
      enableReinitialize
    >
      <Form autoComplete="off">
        {/* <SearchCheckIn isOpenFillter={isOpenFillter}/> */}
        <ListCheckIn
          isOpenFillter={isOpenFillter}
          setOpenFillter={setOpenFillter}
        />
        {openConfirmDelete && (
          <ConfirmPopup
            open={openConfirmDelete}
            onClose={handleCloseConfirmDialog}
            text="Bạn có chắc chắn muốn hủy check in không ?"
            onConfirm={handleConfirmDeleteCheckIn}
          />
        )}
      </Form>
    </Formik>
  );
});

const AdviseDetail = observer(({ patientId }) => {
  const { searchAdvise, handleChangeFormSearch, resetStore } =
    useStore().patientManagementStore.listAdviseStore;
  let [isOpenFillter, setOpenFillter] = useState(true);
  useEffect(() => {
    if (patientId) {
      handleChangeFormSearch({
        ...searchAdvise,
        getItems: true,
        patientId,
        fromDate: null,
        toDate: null,
      });
    }
  }, [patientId]);

  // useEffect(() => {
  //   return () => resetStore();
  // }, []);
  return (
    <Formik
      initialValues={{ ...searchAdvise, getItems: true }}
      onSubmit={(values) => {
        handleChangeFormSearch(values);
      }}
      enableReinitialize
    >
      <Form autoComplete="off">
        {/* <SearchListAdvise isOpenFillter={isOpenFillter}/> */}
        <ListAdvise
          isOpenFillter={isOpenFillter}
          setOpenFillter={setOpenFillter}
        />
      </Form>
    </Formik>
  );
});

export default memo(observer(HistoryIndex));
